import { render, staticRenderFns } from "./AccessUpdate.vue?vue&type=template&id=57c11c15&scoped=true"
import script from "./AccessUpdate.vue?vue&type=script&lang=ts"
export * from "./AccessUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c11c15",
  null
  
)

export default component.exports